import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../common/app';
/**
 * The `Session` class defines the current user session. It stores a reference
 * to the current authenticated user, and provides methods to log in/out.
 */
export default class Session {
  constructor(user, csrfToken) {
    /**
     * The current authenticated user.
     */
    _defineProperty(this, "user", void 0);
    /**
     * The CSRF token.
     */
    _defineProperty(this, "csrfToken", void 0);
    this.user = user;
    this.csrfToken = csrfToken;
  }

  /**
   * Attempt to log in a user.
   */
  login(body, options) {
    if (options === void 0) {
      options = {};
    }
    return app.request({
      method: 'POST',
      url: `${app.forum.attribute('baseUrl')}/login`,
      body,
      ...options
    });
  }

  /**
   * Log the user out.
   */
  logout() {
    window.location.href = `${app.forum.attribute('baseUrl')}/logout?token=${this.csrfToken}`;
  }
}
flarum.reg.add('core', 'common/Session', Session);